import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { Button, ButtonToolbar, Card, CardBody, Col, Modal, Row } from 'reactstrap';
import LoadingIcon from 'mdi-react/LoadingIcon';
import Select from 'react-select';
import { uncheckAllSelectedApplicants } from '../../redux/actions';
import api from '@/utils/apiClient';

export const ApplicantUpdateStageDialog = ({ show, onHide }) => {
  const dispatch = useDispatch();
  const { rtl } = useSelector((state) => state, shallowEqual);
  const checkedApplicantIds = useSelector(
    (state) => state.applicants.checkedApplicantIds,
    shallowEqual,
  );

  const [stage, setStage] = useState({
    value: null,
    label: 'Select Stage',
  });
  const [modal, setModal] = useState({
    isOpen: show,
    hide: onHide,
    loading: false,
    updateStageSuccess: false,
    updateStageError: false,
  });

  const handleUpdateStage = async () => {
    setModal({
      ...modal,
      loading: true,
    });
    const response = await api.applicants.updateStageForProgramApplicant(
      checkedApplicantIds,
      stage.value,
    );
    let updatedModal = {};
    if (response.isSuccess) {
      updatedModal = {
        loading: false,
        updateStageSuccess: true,
      };
    } else {
      updatedModal = {
        loading: false,
        updateStageError: true,
      };
    }
    setModal({ ...modal, ...updatedModal });
  };

  const [applicantsStageOption, setApplicantsStageOption] = useState([]);

  const getProgramApplicationStageOptions = async () => {
    try {
      const { data: res, isSuccess } = await api.applicants.getProgramApplicationStageOptions();
      if (isSuccess) {
        setApplicantsStageOption(
          res.data.map((stage) => ({ value: stage.id, label: stage.title })),
        );
      } else {
        throw new Error('error while fetching applicant stage');
      }
    } catch (error) {
      console.error('Error inside applicant type', error.message);
    }
  };

  useEffect(() => {
    getProgramApplicationStageOptions();
  }, []);

  return (
    <Modal
      isOpen={show}
      toggle={modal.hide}
      onExit={() => dispatch(uncheckAllSelectedApplicants())}
      keyboard={false}
      backdrop={'static'}
      modalClassName={`${rtl.direction}-support`}
      className="modal-dialog--primary modal-dialog--header"
    >
      <div className="modal__header">
        <button
          className="lnr lnr-cross modal__close-btn"
          aria-label="modal__close-btn"
          type="button"
          onClick={modal.hide}
        />
        <h4 className="text-modal  modal__title">Edit stage</h4>
      </div>
      <div>
        <div className="ml-4">
          {modal.loading && (
            <div>
              <div className="panel__refresh position-relative" style={{ height: 75, width: 20 }}>
                <LoadingIcon />
                <div style={{ width: 200, padding: '23px 30px' }}>Updating stage...</div>
              </div>
            </div>
          )}
          {(modal.updateStageSuccess || !!modal.updateStageError) && (
            <>
              <table className="mt-3">
                <tr>
                  <td>
                    {modal.updateStageSuccess ? (
                      <span className="lnr lnr-thumbs-up modal__title-icon success" />
                    ) : (
                      <span className="lnr lnr-cross-circle modal__title-icon error" />
                    )}
                  </td>
                  <td className="pl-2">
                    {modal.updateStageSuccess
                      ? 'Stage Updated successfully!'
                      : 'Error Performing Stage Update!'}
                  </td>
                </tr>
              </table>
            </>
          )}
        </div>
        <Row>
          <Col md={12} lg={12}>
            <Card className="pb-0">
              <CardBody>
                <div className="form-wrapper">
                  <div className="form">
                    <div className="form__form-group">
                      <span className="form__form-group-label">Select Stage</span>
                      <div className="form__form-group-field">
                        <Select
                          name="stage"
                          value={stage}
                          onChange={setStage}
                          autosize={true}
                          options={applicantsStageOption}
                          clearable={false}
                          className="react-select"
                          placeholder={'Select Stage'}
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>
                    <ButtonToolbar className="modal__footer btn-toolbar">
                      <>
                        <Button
                          color="primary"
                          type="submit"
                          disabled={!stage.value}
                          onClick={handleUpdateStage}
                        >
                          Submit
                        </Button>
                        <Button
                          color="secondary"
                          type="button"
                          className="modal_cancel btn btn-secondary"
                          onClick={() => modal.hide()}
                        >
                          Close
                        </Button>
                      </>
                    </ButtonToolbar>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};
